import { render, staticRenderFns } from "./Retrievepassword.vue?vue&type=template&id=2ff20654&scoped=true"
import script from "./Retrievepassword.vue?vue&type=script&lang=js"
export * from "./Retrievepassword.vue?vue&type=script&lang=js"
import style0 from "./Retrievepassword.vue?vue&type=style&index=0&id=2ff20654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff20654",
  null
  
)

export default component.exports